import { modifier } from 'ember-modifier';
import { later } from '@ember/runloop';

export default modifier(
  function containerHeight(element, params, { containerElementId, layoutMode }) {
    this.element = element;
    this.layoutMode = layoutMode
    this.containerElement = containerElementId
      ? document.getElementById(containerElementId)
      : element;

    var setHeightVariables = () => {
      later(() => {
        let containerDimensions = this.containerElement.getBoundingClientRect();
        let containerHeight;
        if (this.layoutMode === 'window') {
          containerHeight = `100vh`;
        } else {
          containerHeight = `${containerDimensions.height}px`
        }
        let elementDimensions = element.getBoundingClientRect();
        let elementHeight = `${elementDimensions.height}px`;

        // console.log('containerHeight:', containerHeight, this.containerElement);
        // console.log('elementHeight:', elementHeight, this.element);

        this.element.style.setProperty('--container-height', containerHeight);
        this.element.style.setProperty('--element-height', elementHeight);
      }, 150);
    }

    const mutationObserver = new MutationObserver(setHeightVariables);
    const resizeObserver = new ResizeObserver(setHeightVariables);
    mutationObserver.observe(this.containerElement, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    resizeObserver.observe(this.containerElement)
    document.addEventListener('scroll', setHeightVariables);
    setHeightVariables();

    return () => {
      document.removeEventListener('scroll', setHeightVariables);
      mutationObserver.disconnect();
    };
  },
  { eager: false },
);
